import { render, staticRenderFns } from "./notificationMessage.vue?vue&type=template&id=07c2610e&"
import script from "./notificationMessage.vue?vue&type=script&lang=js&"
export * from "./notificationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports